/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmSpisovna extends GContentBase<SeznamAdmSpisovnaObj> {
        private seznamObj: SeznamAdmSpisovnaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmSpisovnaObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmSpisovna",
                contentCaption: "jres:33000334", //RC 33000334 : Spisovny
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{nazev}"
                },
                gridSettings: {
                    columnOrder: "zkratka,nazev,poznamka,dat_zmena,zmenu_prov_txt,ixs_spi,ixs_su_txt,typ_spi_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmSpisovnaObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmSpisovna", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmSpisovna",
                newRecord: isNew,
                ixs_spi: isNew == true ? null : data.ixs_spi
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actSeznamAdmFunkcniMistoSpisovna: {
                    icon: "fa-link",
                    caption: "jres:33000357", //RC 33000357 : P�i�azen� funkce
                    run: (ev, ctx) => {
                        var activeRow = this.grid.ggrid("activeRow");
                        if (activeRow)
                            Gordic.Adm.WebControls.AdmSpisovna.openSeznamAdmFunkcniMistoSpisovna(activeRow);
                    }
                },
                actSeznamAdmSpisovnaKategorieDokumentu: {
                    icon: "fa-link",
                    caption: "jres:33000840",
                    run: (ev, ctx) => {
                        this.seznamAdmSpisovnaKategorieDokumentu();
                    }
                },
                actHromadnaOperaceAdmSpisovnaKategorieDokumentu: {
                    icon: "fa-link",
                    caption: "jres:33000845", //RC 33000845 : Hromadn� p�i�azen� kat. dokument�
                    run: (ev, ctx) => {
                        this.hromadnaOperaceAdmSpisovnaKategorieDokumentu();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", {
                favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                    { action: this.cnt.actions.actSeznamAdmFunkcniMistoSpisovna },
                    { action: this.cnt.actions.actSeznamAdmSpisovnaKategorieDokumentu },
                    { action: this.cnt.actions.actHromadnaOperaceAdmSpisovnaKategorieDokumentu }
                ]
            }]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actSeznamAdmFunkcniMistoSpisovna*",
                "actSeznamAdmSpisovnaKategorieDokumentu*"
            ])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmSpisovna.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actSeznamAdmFunkcniMistoSpisovna?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actSeznamAdmSpisovnaKategorieDokumentu?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actHromadnaOperaceAdmSpisovnaKategorieDokumentu?.update({ enabled: objArr.count >= 1 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_spi}`,
                nazev: data.nazev
            }
        }

        private seznamAdmSpisovnaKategorieDokumentu() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                $.content().navigate(["Gordic.Adm.WebControls.SeznamAdmSpisovnaKategorieDokumentu", {
                    ixs_spi: activeRow.ixs_spi
                }])
        }

        private hromadnaOperaceAdmSpisovnaKategorieDokumentu() {
            var selection = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmSpisovnaKategorieDokumentuDto[] = [];
            if (selection.length > 0) {
                selection.forEach((item) => {
                    data.push({
                        ixs_spi: item["ixs_spi"]
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmSpisovnaKategorieDokumentu"], { ID: "HromadnaOperaceAdmSpisovnaKategorieDokumentu", data: data }, "", 1000, 600)
        }
    }
}